var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartAvgLine, ChartBackgroundAreas, ChartRaggedLine, ChartGridMonth } from '../svg-elements/module';
import { HtmlCircle } from '../html-elements/module';
import { getNeededColumnsForHistoryV2, groupByMonths } from "../d3-services/data-with-history.functions";
import { GraphControllerV2 } from "./graph-v2";
import { flattenColumn } from "../d3-services/_helpers";
var CijfersMonths = /** @class */ (function (_super) {
    __extends(CijfersMonths, _super);
    function CijfersMonths(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    CijfersMonths.prototype.pre = function () {
        this._addScale("x", "time", "horizontal", "_date");
        this._addScale("y", "linear", "vertical", flattenColumn(this.mapping.parameters[0][1].column));
        this._addPadding(0, 0, 0, 0);
        this._addMargin(0, 0, 10, 10);
    };
    CijfersMonths.prototype.init = function () {
        var _this = this;
        _super.prototype._init.call(this);
        // create svg elements without data
        this.chartLine = new ChartRaggedLine(this);
        this.chartBackgroundAreas = new ChartBackgroundAreas(this);
        this.chartGrid = new ChartGridMonth(this);
        this.chartAvgLine = new ChartAvgLine(this);
        this.htmlCircle = new HtmlCircle(this);
        this.htmlCircle.draw();
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = "100px";
        container.style.width = "100%";
        container.style.marginBottom = '3rem';
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.config.extra.decimal = true;
        if (this.data.map(function (i) { return i[_this.firstMapping['column']]; }).filter(function (i) { return i !== null && i !== undefined; }).length > 2) {
            this.chartAvgLine.draw();
        }
        this.update(this.data, this.segment, false);
    };
    CijfersMonths.prototype.prepareData = function (data) {
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping);
        var history = groupByMonths(data, neededColumns);
        this.main.dataStore.setGraph(this.mapping.slug, history);
        return {
            "history": history,
            "latest": data[0],
            "slice": history.slice(2, 10),
        };
    };
    CijfersMonths.prototype.redraw = function (data) {
        var _this = this;
        _super.prototype.redraw.call(this, data);
        this.htmlCircle.redraw([data.latest], this.firstMapping['column']);
        if (data.slice.map(function (i) { return i[_this.firstMapping['column']]; }).filter(function (i) { return i !== null && i !== undefined; }).length > 2) {
            this.chartBackgroundAreas.redraw(data.slice, this.firstMapping['colour']);
            this.chartGrid.redraw(data.slice, this.firstMapping['colour']);
            this.chartLine.redraw(data.slice, this.firstMapping['colour']);
            this.chartAvgLine.redraw(data);
        }
    };
    CijfersMonths.prototype.draw = function (data) {
        var _this = this;
        this.scales.x.set(data.slice.map(function (d) { return d[_this.parameters.x]; }));
        var minValue = (this.config.extra.period === 'monthly') ? 7 : 0;
        this.scales.y.set(data.history.map(function (d) { return d[_this.parameters.y]; }), minValue);
        if (data.slice.map(function (i) { return i[_this.firstMapping['column']]; }).filter(function (i) { return i !== null && i !== undefined; }).length > 2) {
            this.chartBackgroundAreas.draw(data.slice);
            this.chartLine.draw(data.slice);
            this.chartGrid.draw(data.slice);
        }
        // this.popup.attachData([data.latest])
    };
    CijfersMonths.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return CijfersMonths;
}(GraphControllerV2));
export default CijfersMonths;
